(() => {
  const getCartDrawer = () => document.querySelector('cart-drawer[data-elo-cart-v19]');

  const openCartPageDrawer = () => {
    const drawer = getCartDrawer();
    if (drawer && !drawer.classList.contains('active')) drawer.open();
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[data-elo-cart-page]')) window.setTimeout(openCartPageDrawer, 60);
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-elo-cart-page-open]')) return;
    openCartPageDrawer();
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-elo19-upsell-variant]');
    if (!select) return;

    const card = select.closest('.elo19-upsell__card');
    const option = select.selectedOptions[0];
    const image = card?.querySelector('[data-elo19-upsell-image]');
    const price = card?.querySelector('[data-elo19-upsell-price]');
    if (image && option?.dataset.image) image.src = option.dataset.image;
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-elo19-upsell]');
    if (!form) return;

    event.preventDefault();
    const drawer = getCartDrawer();
    const button = form.querySelector('button[type="submit"]');
    if (!drawer || !button || button.disabled || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const body = new FormData(form);
      body.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();

      if (!response.ok || state.status) throw new Error(state.description || 'Продуктът не можа да бъде добавен.');
      drawer.renderContents(state);
      window.EloGiftV20?.schedule(80);
    } catch (error) {
      const errorBox = drawer.querySelector('#CartDrawer-CartErrors');
      if (errorBox) errorBox.textContent = error.message || window.cartStrings?.error || 'Възникна грешка.';
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
})();
